/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams } from "../models/UsersAuthzAPIUserPermissionsReadCheckUserPermission";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzAPIUserPermissionsReadCheckUserPermission } from "../axios/usersAuthzAPIUserPermissionsReadCheckUserPermission";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey = (permission: UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams["permission"]) => ["users-authz-api", { url: '/user/permissions/:permission', params: {permission:permission} }] as const

export type UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey = ReturnType<typeof usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey>

export function usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryOptions(permission: UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey(permission)
  return queryOptions<UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, ResponseErrorConfig<Error>, UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, typeof queryKey>({
   enabled: !!(permission),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return usersAuthzAPIUserPermissionsReadCheckUserPermission(permission, config)
   },
  })
}

/**
 * @summary Check if the current user has a specific permission
 * {@link /user/permissions/:permission}
 */
export function useUsersAuthzAPIUserPermissionsReadCheckUserPermission<TData = UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, TQueryData = UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, TQueryKey extends QueryKey = UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey>(permission: UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams["permission"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryKey(permission)

  const query = useQuery({
   ...usersAuthzAPIUserPermissionsReadCheckUserPermissionQueryOptions(permission, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}